import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { parsePhoneNumberFromString } from 'libphonenumber-js';
class MaskedCallModal extends React.Component {

	render () {
        return (
            <div>
                <p>
                    {this.props.state.isMobileVersion ? __('Masked Call allows you to call a Feedbacker from this phone without exposing your caller ID. When you initiate a Masked Call, a call will be made to the Feedbacker from this phone and display a different caller ID. If the Feedbacker calls the phone number displayed, the call will be routed to this phone.') : __('Masked Call allows you to call a Feedbacker from your phone without exposing your caller ID. When you initiate a Masked Call, a call will be made to the Feedbacker from your phone :employee_phone and display a different caller ID. If the Feedbacker calls the phone number displayed, the call will be routed to your phone.', {':employee_phone': this.props.state.authenticatedUserPhone})}
                </p>
                
                {this.props.state.proxyService ?
                    <p className="mt-2">
                        {__('To call :first_name, please dial',{':first_name':this.props.state.feedback_detail.user.firstname})}

                        {this.props.state.proxyService.data ? 
                                <span>
                                    <br/><a href="tel:{this.props.state.proxyService.data.proxy}">{parsePhoneNumberFromString(this.props.state.proxyService.data.proxy).format('NATIONAL')}</a>
                                </span>
                            :
                                " [Number Did Not Get Created OOPS!] "
                        }
                        <br/>
                        {__('from your phone number :employee_phone now.', {':employee_phone': this.props.state.authenticatedUserPhone})}
                    </p> : null
                }
            </div>
        )
            
	}
}

function mapStateToProps(state) {
	return { state:state }
}

export default connect(mapStateToProps)(MaskedCallModal);
